// src/reducers/userReducer.js
import {
    GET_SOCIAL_SUCCESS,
    GET_SOCIAL_FAILURE,
  } from "../../actions/types";
  
  const initialState = {
    isLoading: false,
    response: null,
    error: null,
  };
  
  export const socialReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_SOCIAL_SUCCESS:
        return {
          ...state,
          isLoading: false,
          response: action.payload,
          error: null,
        };
      case GET_SOCIAL_FAILURE:
        return {
          ...state,
          isLoading: false,
          response: null,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  